import { observer } from 'mobx-react';
import { FC, useMemo } from 'react';
import ModifierAndExclusionModalItem from '../../components/ModifierAndExclusionModalItem/ModifierAndExclusionModalItem';
import { mdfAndExclModalStore } from '../../store';
import { localeStore } from 'src/mobx/localesStore';
import { emptyArray, getTranslate } from 'src/utils/helpers';
import { findSubstring } from 'src/utils/parser';

const ModifierAndExclusionModalContent: FC = observer((): JSX.Element => {
  const { loading, searchValue, isModifiersSection, isSelectedCrumb, currentSectionSelectedItems, pagination } = mdfAndExclModalStore;

  const noFoundText = useMemo((): string => localeStore.t(isModifiersSection ? 'no_modifiers_found' : 'no_exclusions_found'), [isModifiersSection]);

  const selectedItems = useMemo(() => {
    return [...currentSectionSelectedItems].filter((item) => findSubstring(getTranslate(item.name), searchValue));
  }, [currentSectionSelectedItems, searchValue]);

  const itemsForRender = useMemo(() => {
    return isSelectedCrumb ? selectedItems : pagination.data;
  }, [isSelectedCrumb, selectedItems, pagination.data]);

  if (loading)
    return (
      <>
        {emptyArray().map((_, index) => (
          <ModifierAndExclusionModalItem key={'key-' + String(index)} />
        ))}
      </>
    );

  if (!itemsForRender.length) {
    return (
      <div className="d-flex full-height full-width align-items-center">
        <p className="family-bold text-size-26 color-dark mx-auto my-auto">{noFoundText}</p>
      </div>
    );
  }

  return (
    <>
      {itemsForRender.map((item) => (
        <ModifierAndExclusionModalItem key={item.id} item={item} />
      ))}
    </>
  );
});

export default ModifierAndExclusionModalContent;
